import { useState } from 'react';

import { Row, Tooltip } from 'farmhub-ui-core';

import { ViewTagModal } from 'containers/WarehouseOperation/WorkSpace/components';
import { theme } from 'styled';

import { TagOption } from '../index';
import { Wrapper } from './styles';

interface ViewTagGroupProps {
  id?: string;
  name?: string;
  tags: any[];
  type?: 'PRODUCT' | 'ORDER' | 'ENTITY';
  maxWidth?: string;
}

const ViewTagGroup = ({
  id,
  name,
  tags,
  type = 'PRODUCT',
  maxWidth = '180px !important',
}: ViewTagGroupProps): JSX.Element => {
  const [isVisibleViewTagModal, setIsVisibleViewTagModal] = useState(false);

  const handleChangeIsVisibleViewTagModal = (e: boolean) => {
    setIsVisibleViewTagModal(e);
  };

  return (
    <Wrapper>
      <ViewTagModal
        id={id}
        initOptions={tags}
        isVisible={isVisibleViewTagModal}
        name={name}
        setIsVisible={handleChangeIsVisibleViewTagModal}
        type={type}
      />
      <Row>
        {(tags?.slice(0, 2) || []).map((tag: any, index: number) => (
          <Tooltip title={tag?.content}>
            <div>
              <TagOption
                color={tag?.color?.code}
                label={tag?.content}
                styles={{
                  'max-width': maxWidth,
                  'margin-bottom': '6px',
                  'margin-right': '6px',
                }}
                onClick={() => handleChangeIsVisibleViewTagModal(true)}
              />
            </div>
          </Tooltip>
        ))}
        {tags?.length > 2 && (
          <div style={{ minWidth: '72px' }}>
            <TagOption
              hideDot
              color={theme.colors.text.primary}
              label="Xem thêm"
              styles={{
                'margin-bottom': '6px',
              }}
              onClick={() => {
                handleChangeIsVisibleViewTagModal(true);
              }}
            />
          </div>
        )}
      </Row>
    </Wrapper>
  );
};

export default ViewTagGroup;
